/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Settlement_Bank_DriverInputs */

const vi_order_settlement_bank_driver = /** @type {(inputs: Order_Settlement_Bank_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TK riêng của tài xế`)
};

/**

* @param {Order_Settlement_Bank_DriverInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_settlement_bank_driver = /** @type {((inputs?: Order_Settlement_Bank_DriverInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Settlement_Bank_DriverInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_settlement_bank_driver(inputs)
});